import { IDV_PAGE } from '@belong/chat-utils';
import { isBrowser } from '@belong/env';
import { useIsSessionsV2Enabled } from './useIsSessionsV2Enabled';

// Open link in new tab if it's not support page
export const useShouldOpenInNewTab = (): boolean => {
  const isSessionsV2Enabled = useIsSessionsV2Enabled();

  if (!isBrowser()) {
    return false;
  }

  return isSessionsV2Enabled && window.parent?.location.pathname?.startsWith(IDV_PAGE);
};
